<template>
  <div id="app" :class="['layout', { 'layout--no-sidebar': !hasSidebar }]">
    <Header :showLinks="showLinks" />
    <Chat />

    <div class="layout__main">
      <div class="layout__breadcrumbs">
        <slot name="breadcrumbs" />
      </div>

      <div class="layout__sidebar" v-if="hasSidebar">
        <slot name="sidebar" />
      </div>

      <div class="layout__content">
        <slot />
      </div>
    </div>
    <Chat />

    <Footer />
  </div>
</template>

<script>
import "../../icons/"; // TODO - check if icons are necessary
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  components: {
    Header,
    Footer
  },
  props: {
    showLinks: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    hasSidebar() {
      return !!this.$slots.sidebar;
    }
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: block;
  background: $--color-white;
}

.layout__main {
  margin: 0 auto;
  padding: 0 $gutter-width / 2;
  max-width: $container-width;
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  min-height: 100vh;
}

.layout__breadcrumbs {
  padding: rem(22) 0 rem(40);
  width: 100%;
  position: relative;
  @include media("<navbar-sm") {
    padding-bottom: rem(10);
  }
}

.layout__sidebar {
  width: 237px;
  border-right: 1px solid $--color-gray-0;
  @include media("<navbar-sm") {
    width: 100%;
    border: none;
  }
}

.layout__content {
  padding-left: 26px;
  width: calc(100% - 237px);
  @include media("<navbar-sm") {
    padding-left: 0;
    width: 100%;
  }
}

.layout--no-sidebar {
  .layout__content {
    padding-left: 0;
    width: 100%;
  }
}
</style>
